import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createMetaManager } from 'vue-meta';
import '@/styles/base.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClock, faHandshake, faQuestionCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowLeft,
  faCheckCircle,
  faCircle,
  faCog,
  faDownload,
  faEllipsisV,
  faExclamationCircle,
  faExternalLinkAlt,
  faLanguage,
  faMicrophone,
  faPaperclip,
  faSquare,
  faTimes,
  faUpload,
  faVideo,
  faVideoSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import i18n from './i18n';

library.add(
  faCheckCircle as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faQuestionCircle as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faVideo as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faTimes as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faUpload as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faTimesCircle as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faMicrophone as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faLanguage as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faCog as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faCircle as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faSquare as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faEllipsisV as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faPaperclip as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faClock as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faVideoSlash as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faExternalLinkAlt as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faHandshake as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faDownload as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faExclamationCircle as import('@fortawesome/fontawesome-svg-core').IconDefinition,
  faArrowLeft as import('@fortawesome/fontawesome-svg-core').IconDefinition,
);

const app = createApp(App)
  .use(store)
  .use(router)
  .use(createMetaManager())
  .component('font-awesome-icon', FontAwesomeIcon);

app.use(i18n);

app.mount('#app');
